import React, { Component } from 'react';

import { FeedbackModal } from '../modals';

class ResourcesPage extends Component {

  state = {
    showingFeedbackModal: false,
  }

  renderFeedbackModal(){
    return <FeedbackModal
      visible={this.state.showingFeedbackModal}
      hide={() => { this.setState({ showingFeedbackModal: false }); }}
    />;
  }

  showFeedbackCollect(){
    this.setState({
      showingFeedbackModal: true
    });
  }

  render(){
    return (
      <div className="page resources">
        <h1>Resources page</h1>
        <p style={{fontSize: 18}}>What resources would you like to see here? Please let us know!</p>
        <button onClick={this.showFeedbackCollect.bind(this)} className="button primary">Request a resource...</button>

        {this.renderFeedbackModal()}
      </div>
    )
  }
}

export default ResourcesPage;



// WEBPACK FOOTER //
// ./src/components/resources/index.js